module.exports = __webpack_public_path__ + "img/icon-mail.eda70380.svg";